import React from 'react';
import {
  ImagesContainer, ImagesPack, Image1, Image2,
} from './CoreBancarioImagesContainer.styles';
import Images from '../../assets/images/NosotrosImages/img-nosotros-pack.webp';
import Image11 from '../../assets/images/NosotrosImages/NosotrosImage1.webp';
import Image22 from '../../assets/images/NosotrosImages/Nosotros-Image22.webp';

export const CoreBancarioImagesContainer = () => {
  
  return (
    <ImagesContainer>
      <Image1 src={Image11} alt="Core Bancario Dynamicore" />
      <Image2 src={Image22} alt="Plataforma Core Bancario" />
      <ImagesPack src={Images} alt="Core Bancario Dynamicore" />
    </ImagesContainer>
  );
};
